'use strict';

// Globals and dependencies
/* global Vue */
/* global loadjs */
/* global axios */
/* global Swal */

loadjs.ready(['vue'], {
  success: function success() {
    // Use Modal Components
    Vue.use(window['vue-js-modal'].default);

    // Define a new component called support-button
    Vue.component('support', {
      data: function data() {
        return { message: {}, errors: {}, error: '', response: null, submitted: false };
      },
      methods: {
        contactSupport: function contactSupport() {
          var _this = this;

          this.submitted = true;

          var params = new URLSearchParams();
          params.append(window.site.App.config('csrfName'), window.site.App.config('csrf'));

          var obj = this.message;

          Object.keys(obj).forEach(function (key) {
            params.append(key, obj[key]);
          });

          axios.defaults.headers.common = {
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/json'
          };

          axios.post('actions/site-module/default/do-something', params).then(function (response) {
            // Debug
            // console.log(response.data, response.data.body);
            _this.$modal.hide('contact-support-modal');
            _this.response = response;

            _this.resetForm();

            Swal.fire({
              type: 'success',
              title: 'Success',
              text: 'We will be in touch soon.',
              footer: ''
            });
          }).catch(function (response) {
            // Debug
            // console.log(response, response.Error);
            _this.error = response;
          });
        },

        cancel: function cancel() {
          this.$modal.hide('contact-support-modal');

          this.resetForm();
        },

        resetForm: function resetForm() {
          this.message = {};
          this.submitted = false;
        }
      },
      template: '\n        <div>\n          <a\n            @click.prevent="$modal.show(\'contact-support-modal\')"\n            href="#"\n          >\n            Support\n          </a>\n\n          <modal\n            name="contact-support-modal"\n            width="100%"\n            height="auto"\n            :pivotY="1"\n            classes="v--modal contact-support-modal"\n          >\n            <div>\n              <h1>Have a Question?</h1>\n\n              <form\n                autocomplete="off"\n                @submit.prevent="contactSupport"\n                @keydown="submitted = false"\n              >\n\n                <div class="control">\n                  <input\n                    type="text"\n                    name="name"\n                    id="name"\n                    class="modal-input"\n                    placeholder="What\'s your name?"\n                    v-model="message.name"\n                    @keydown="error = \'\'"\n                    required />\n                </div>\n\n                <div class="control">\n                  <input\n                    type="email"\n                    name="email"\n                    id="email"\n                    class="modal-input"\n                    placeholder="Which email address should we respond to?"\n                    v-model="message.email"\n                    @keydown="error = \'\'"\n                    required />\n                </div>\n\n                <div class="control">\n                  <textarea\n                    name="body"\n                    id="body"\n                    data-autosize\n                    class="modal-input"\n                    placeholder="What\'s your question?"\n                    v-model="message.body"\n                    @keydown="error = \'\'"\n                    required\n                  ></textarea>\n                </div>\n\n                <div class="control">\n                  <input\n                    type="text"\n                    name="verification"\n                    id="verification"\n                    class="modal-input"\n                    placeholder="What is 1 + 4?"\n                    v-model="message.verification"\n                    @keydown="error = \'\'"\n                    required />\n                </div>\n\n                <div class="alert-msg error">\n                  <p v-html="error" v-if="error"></p>\n                </div>\n\n                <div class="control-btns">\n                  <a\n                    @click.prevent="cancel"\n                    class="site-btn"\n                    href="#"\n                  >\n                    Cancel\n                  </a>\n\n                  <button\n                    type="submit"\n                    class="site-btn"\n                    :disabled="submitted"\n                  >\n                    Send\n                  </button>\n                </div>\n              </form>\n            </div>\n          </modal>\n        </div>\n      '
    });
  }
});